import { render, staticRenderFns } from "./InvestmentsIadAccount.vue?vue&type=template&id=3cd58428&scoped=true"
import script from "./InvestmentsIadAccount.vue?vue&type=script&lang=js"
export * from "./InvestmentsIadAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd58428",
  null
  
)

export default component.exports